import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ViewCompany from "../../../components/Modal/Admin/ManageCustomer/ViewCompany";
import EditCompany from "../../../components/Modal/Admin/ManageCustomer/EditCompany";
import axiosInstance from "../../../hooks/axiosInstance";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Oval } from "react-loader-spinner";

import { toast } from "react-toastify";

export default function ManageCustomerCompany() {
  const MySwal = withReactContent(Swal);
  const [page, setPage] = useState();
  const [filter, setFilter] = useState("");
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [customers, setCustomers] = useState([]);
  const [company, setCompany] = useState([]);
  const [pagination, setPagination] = useState({});
  const [editDompanyDetails, setCompanyDetails] = useState(null);
  const [companyDetails, setviewCompany] = useState(null);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await axiosInstance.get(
          `/user/customer/fetch_customer_no_paginate`
        );

        // console.log("API Response Data:", response.data.data.customer, 555);
        setCustomers(response.data.data.customer || []);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchCustomers();
  }, [page, filter, refreshKey]);

  const handleCustomerSelect = (event) => {
    setSelectedCustomerId(event.target.value);
  };

  useEffect(() => {
    const fetchCompany = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(
          `/user/company/customer_company`,
          {
            params: {
              page,
              filter,
              // customer_id: selectedCustomerId, // Pass the selected customer ID
              customer_id: selectedCustomerId || "",
            },
          }
        );

        setCompany(response.data.data.company.data || []);
        setPagination(response.data.data.company);
      } catch (error) {
        console.error("Error fetching company details:", error);
      }
      finally {
        setLoading(false); // Hide loader after fetching
      }
    };

    fetchCompany();
  }, [selectedCustomerId, page, filter, refreshKey]);

  const handleClose = () => {
    setShowEdit(false);
    setShowView(false);
    // setChangeImage(false);
  };
  const handleShowView = (company) => {
    setviewCompany(company);
    setShowView(true);
  };

  const handleShowEdit = (company_id) => {
    setCompanyDetails(company_id);
    setShowEdit(true);
  };

  // axiosInstance.post(`/user/company/remove-company/${companyId}`)
  const handleDeleteCompany = async (companyId) => {
    const result = await MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await axiosInstance.post(`/user/company/remove-company/${companyId}`);
        handleRefresh();
        handleClose();
        toast.success("Company removed successfully!");
      } catch (error) {
        toast("Error deleting company:", error);
      }
    }
  };

  const handleRefresh = () => {
    setRefreshKey((prevRefreshKey) => prevRefreshKey + 1);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= pagination.last_page) {
      setPage(newPage);
    }
  };

  useEffect(() => {}, [refreshKey]);

  return (
    <>
      {/* <!-- start page title --> */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0" style={{ color: "#c4281c" }}>
              Manage Customer Companies
            </h4>

            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/app">Dashboard</Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#c4281c" }}
                >
                  Manage Customer Companies
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- end page title --> */}
      {loading && !filter ? ( // Only show loader for general data fetching
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <Oval
            height={80}
            width={80}
            color="#FF0200"
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#4fa94d"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      ) : (
        <div className="row" id="contactList">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header d-flex align-items-center border-0">
                <h5
                  className="card-title mb-0 flex-grow-1"
                  style={{ color: "#c4281b" }}
                >
                  Manage Customer Companies
                </h5>
              </div>
              <div className="card-body border border-dashed border-end-0 border-start-0">
                <div className="row">
                  <div className="col-xl-4 col-md-6">
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Search to customer..."
                        value={filter}
                        onChange={handleFilterChange}
                      />
                      <i className="ri-search-line search-icon"></i>
                    </div>
                  </div>
                  <div className="col-xl-1 col-md-6"></div> <br />

                  <div className="col-xl-4 col-md-6 ml-2">
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          Select a customer &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;{" "}
                        </span>
                      </div>
                      <select
                        className="custom-select form-control"
                        onChange={handleCustomerSelect}
                      >
                        <option value="">--select customer--</option>
                        {customers.map((customer) => (
                          <option key={customer.id} value={customer.id}>
                            {customer.first_name}
                            {/* {customer.last_name} */}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-xl-3 col-md-6"></div>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive table-card">
                  <table
                    className="table align-middle table-nowrap table table-striped table-borderless table-hover"
                    id="customerTable"
                  >
                    <thead className="table-light text-muted">
                      <tr>
                        <th>#</th>
                        <th>
                          {" "}
                          Company Name
                        </th>
                        <th>
                          {" "}
                          Email
                        </th>
                        <th>
                          {" "}
                          Contact Person
                        </th>
                        <th>
                          {" "}
                          State
                        </th>
                        <th>
                          {" "}
                          City
                          </th>
                          <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    {/* <!--end thead--> */}
                    <tbody className="list form-check-all">
                      {company.map((company, index) => (
                        <tr key={company.id}>
                          <td>{index + 1}</td>
                          <td> {company.company_name}</td>
                          <td>{company.email}</td>
                          <td> {company.contact_person_phone}</td>
                          <td> {company.state}</td>
                          <td> {company.city}</td>
                          <td className="status">
                            {company.status === "active" ? (
                              <span className="badge bg-success">Active</span>
                            ) : company.status === "inactive" ? (
                              <span className="badge bg-danger">Inactive</span>
                            ) : null}
                          </td>
                          <td>
                            <div className="dropdown">
                              <button
                                className="btn btn-icon btn-sm fs-16 text-muted dropdown"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="mdi mdi-apps"></i>
                              </button>
                              <ul className="dropdown-menu">
                                <li>
                                  <Link
                                    className="dropdown-item"
                                    onClick={() => handleShowView(company)}
                                  >
                                    <i className="ri-eye-fill text-muted me-2 align-bottom"></i>
                                    View Customer
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    className="dropdown-item"
                                    onClick={() => handleShowEdit(company)}
                                  >
                                    <i className="mdi mdi-pencil me-2 text-success"></i>{" "}
                                    Edit
                                  </Link>
                                </li>
                                {/* {customer.company_id && ( */}
                                <li>
                                  <Link
                                    className="dropdown-item text-danger"
                                    onClick={() =>
                                      handleDeleteCompany(company.company_id)
                                    }
                                  >
                                    <i className="mdi mdi-delete-outline me-1"></i>{" "}
                                    Delete Company
                                  </Link>
                                </li>
                                {/* )} */}
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {/* <!--end table--> */}
                    <div className="d-flex mt-5 mb-5 flex-wrap">
                      <div className="pagination-wrap hstack gap-2 mx-auto">
                      <ul className="pagination listjs-pagination mb-0">
                        {(pagination.links || []).map((link, index) => {
                          const pageNumber = link.url
                            ? new URL(link.url).searchParams.get("page")
                            : null;

                          return (
                            <li
                              key={index}
                              className={`page-item ${
                                link.active ? "active" : ""
                              }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  pageNumber &&
                                  handlePageChange(Number(pageNumber))
                                }
                                dangerouslySetInnerHTML={{ __html: link.label }}
                              ></button>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
      )}
          <EditCompany
            showEdit={showEdit}
            closeModal={handleClose}
            refreshPage={handleRefresh}
            companyDetails={editDompanyDetails}
          />
          <ViewCompany
            showView={showView}
            closeModal={handleClose}
            refreshPage={handleRefresh}
            companyDetails={companyDetails}
          />
    </>
  );
}
